import { useState, useEffect } from 'react';
import { get, find, map, filter } from 'lodash';

import request from '../../../../../request';
import {
  AI_CONVERSATIONAL_ANSWER_TYPES,
  TRANSFORMATION_DATA_TYPE_JSON,
} from '../../../../../constants';

function useInitializeAi(question) {
  const [sessionId, setSessionId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    async function initializeAi() {
      const deviceId = Pollfish.helper.json.raw.device_id;
      const surveyId = Pollfish.survey.getSurveyId();
      try {
        setLoading(true);
        const answers = get(question, 'answers', []);
        const answerTypes = get(question, 'matrix.answerColumnValueTypes', []);
        const objectiveId = find(answerTypes, [
          'cellType',
          AI_CONVERSATIONAL_ANSWER_TYPES.OBJECTIVE,
        ])?.answerId;
        const goalIds = map(
          filter(answerTypes, [
            'cellType',
            AI_CONVERSATIONAL_ANSWER_TYPES.GOAL,
          ]),
          'answerId',
        );
        const objective = find(answers, ['id', objectiveId])?.body;
        const goals = map(
          filter(answers, (answer) => goalIds.includes(answer.id)),
          ({ body, refId: referenceId }, index) => ({
            body,
            reference_id: referenceId,
            order: index + 1,
          }),
        );

        const initialData = await request({
          url: `/v2/device/conversational/chat/questions/${question.id}/devices/${deviceId}/init`,
          method: 'POST',
          contentType: 'application/json; charset=utf-8',
          transformData: true,
          transformationDataType: TRANSFORMATION_DATA_TYPE_JSON,
          data: {
            survey_id: surveyId,
            objective,
            key_goals: goals,
          },
        });
        setSessionId(initialData);
      } catch (err) {
        console.error(
          `Failed to initialize AI for the question ${question.id}`,
        );
        Raven.captureMessage(
          `Failed to initialize AI for the question ${question.id}`,
          { extra: { question, deviceId, surveyId } },
        );
        setError(true);
      } finally {
        setLoading(false);
      }
    }
    initializeAi();
  }, [question]);

  return { sessionId, loading, error };
}

export default useInitializeAi;
